import PropTypes from 'prop-types';

const Loader = ({ className, isLoading, children }) => {
    return (
        isLoading ? (<div className="flex h-full w-full justify-center items-center">
                <div className={`logo ${className}`} />
            </div>) : children
    );
};

Loader.propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired

};

export { Loader };